import React, { useState, useEffect } from 'react'

export default function FeatureLayerWidget(props) {
    const {
        layer,
        map,
        setActiveLayers
    } = props;

    const initiallyChecked = map.current.getStyle().layers.filter((l) => l.id.includes(layer.id))[0].layout.visibility === 'visible' ? true : false;

    const [checked, setChecked] = useState(initiallyChecked);

    useEffect(() => {
        const selected = map.current.getStyle().layers.find((l) => l.id.includes(layer.id));
    
        if (selected) {
            map.current.setLayoutProperty(selected.id, 'visibility', checked ? 'visible' : 'none');
    
            setActiveLayers((prevLayers) => {
                if (checked) {
                    return prevLayers.some((l) => l.id === selected.id)
                        ? prevLayers
                        : [...prevLayers, selected];
                } else {
                    return prevLayers.filter((l) => l.id !== selected.id);
                }
            });
        }
    }, [checked, layer.id, map, setActiveLayers]);    

    return (
        <div className='weather-widgets-feature-layer-widget-expandable-expanded-row'>
            <input 
                className='weather-widgets-feature-layer-widget-expandable-expanded-row-check' 
                type='checkbox'
                checked={checked}
                onChange={(e) => {
                    setChecked(e.target.checked);
                }}
            />
            <img
                className='weather-widgets-feature-layer-widget-expandable-expanded-row-icon'
                src={layer.icon}
            />
            <div
                className='weather-widgets-feature-layer-widget-expandable-expanded-row-name'
            >
                {layer.name}
            </div>
        </div>
    )
}

